import { RouteObject } from "react-router-dom";
import FlussInboxPage from "modules/fluss/pages/FlussInboxPage";
import FlussInstanceDetailPage from "modules/fluss/pages/FlussInstanceDetailPage";
import FlussMonitorPage from "modules/fluss/pages/FlussMonitorPage";
import FlussRepositoryPage from "modules/fluss/pages/FlussRepositoryPage";
import FlussRequestDetailPage from "modules/fluss/pages/FlussRequestDetailPage";
import FlussRequestsPage from "modules/fluss/pages/FlussRequestsPage";
import FlussStudioPage from "modules/fluss/pages/FlussStudioPage";
import FlussTaskPage from "modules/fluss/pages/FlussTaskPage";

const FLUSS_ROUTES: RouteObject[] = [
    {
        path: "fluss",
        element: <FlussRepositoryPage />,
    },
    {
        path: "fluss/definitions/:definitionId",
        element: <FlussStudioPage />,
    },
    {
        path: "fluss/inbox",
        element: <FlussInboxPage />,
    },
    {
        path: "fluss/inbox/:taskId",
        element: <FlussTaskPage />,
    },
    {
        path: "fluss/requests",
        element: <FlussRequestsPage />,
    },
    {
        path: "fluss/requests/:instanceId",
        element: <FlussRequestDetailPage />,
    },
    {
        path: "fluss/monitor",
        element: <FlussMonitorPage />,
    },
    {
        path: "fluss/monitor/:instanceId",
        element: <FlussInstanceDetailPage />,
    },
];

export default FLUSS_ROUTES;
